import React, { useState, useEffect } from "react";
import Select from "react-select";
import { onlyNumericInput } from "@/utils";
import { useGetAddressCodeQuery, useGetAddressCode2Mutation } from "@/redux/metaApi";

export const FormInsurance = ({ formData, handleChange, setFormData }) => {
    const { data: loc1 } = useGetAddressCodeQuery({ take_1_step: true, take_2_step: false });
    const [getAddressCode2, { data: loc2 }] = useGetAddressCode2Mutation();

    // 선택된 2차 지역 데이터를 저장하는 상태
    const [loc2DataMap, setLoc2DataMap] = useState({});

    // 담당 지역 목록 상태
    const [workLocations, setWorkLocations] = useState([{ id: 1, location1AddressCodeId: null, location2AddressCodeId: null }]);

    // workLocations가 변경될 때마다 formData 업데이트
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            insuranceCorpInfo: {
                ...prev.insuranceCorpInfo,
                workLocations: workLocations.map(({ location1AddressCodeId, location2AddressCodeId }) => ({
                    location1AddressCodeId,
                    location2AddressCodeId,
                })),
            },
        }));
    }, [workLocations]);

    // 지역 추가 핸들러
    const handleAddLocation = () => {
        setWorkLocations((prev) => [
            ...prev,
            {
                id: Math.max(...prev.map((loc) => loc.id), 0) + 1,
                location1AddressCodeId: null,
                location2AddressCodeId: null,
            },
        ]);
    };

    // 지역 삭제 핸들러
    const handleRemoveLocation = (id) => {
        setWorkLocations((prev) => prev.filter((loc) => loc.id !== id));
    };

    // 1차 지역 선택 핸들러
    const handleLocation1Change = (option, locationId) => {
        getAddressCode2({ take_1_step: false, take_2_step: true, parent_b_code: option.bcode });
        setLoc2DataMap((prev) => ({ ...prev, [locationId]: [] }));
        setWorkLocations((prev) =>
            prev.map((loc) =>
                loc.id === locationId ? { ...loc, location1AddressCodeId: option.value, location2AddressCodeId: null } : loc
            )
        );
    };

    // 2차 지역 선택 핸들러
    const handleLocation2Change = (option, locationId) => {
        setWorkLocations((prev) => prev.map((loc) => (loc.id === locationId ? { ...loc, location2AddressCodeId: option.value } : loc)));
    };

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>보험사명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.insuranceCorpInfo.insuranceCorpName"
                            placeholder="보험사명"
                            value={formData?.member?.insuranceCorpInfo?.insuranceCorpName}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>직함</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.insuranceCorpInfo.position"
                            placeholder="직함"
                            value={formData?.member?.insuranceCorpInfo?.position}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>팩스번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.insuranceCorpInfo.faxNumber"
                            placeholder="팩스번호"
                            value={formData?.member?.insuranceCorpInfo?.faxNumber}
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={11}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>담당 지역 설정</span>
                </div>
                <div className="row-content">
                    {workLocations.map((location) => (
                        <div key={location.id} className="form-content-row" style={{ marginBottom: "10px" }}>
                            <div className="form-element">
                                <Select
                                    options={loc1?.data.map((item) => ({
                                        value: item.id,
                                        label: item.address1,
                                        bcode: item.bCode,
                                    }))}
                                    className="custom-select"
                                    classNamePrefix="custom-select"
                                    isSearchable
                                    placeholder="1차 지역"
                                    value={
                                        loc1?.data
                                            .filter((item) => item.id === location.location1AddressCodeId)
                                            .map((item) => ({
                                                value: item.id,
                                                label: item.address1,
                                                bcode: item.bCode,
                                            }))[0]
                                    }
                                    onChange={(option) => handleLocation1Change(option, location.id)}
                                />
                            </div>
                            <div className="form-element">
                                <Select
                                    options={loc2?.data.map((item) => ({
                                        value: item.id,
                                        label: item.address2,
                                        bcode: item.bCode,
                                    }))}
                                    className="custom-select"
                                    classNamePrefix="custom-select"
                                    isSearchable
                                    placeholder="2차 지역"
                                    value={
                                        loc2?.data
                                            .filter((item) => item.id === location.location2AddressCodeId)
                                            .map((item) => ({
                                                value: item.id,
                                                label: item.address2,
                                                bcode: item.bCode,
                                            }))[0]
                                    }
                                    onChange={(option) => handleLocation2Change(option, location.id)}
                                />
                            </div>
                            {workLocations.length > 1 && (
                                <button type="button" className="btn-delete" onClick={() => handleRemoveLocation(location.id)}>
                                    삭제
                                </button>
                            )}
                        </div>
                    ))}
                    <div className="form-content-row">
                        <div className="form-element_button">
                            <button type="button" className="btn-add" onClick={handleAddLocation}>
                                지역 추가
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
